import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaQuoteLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const testimonials = [
  {
    id: 1,
    name: 'Mike May',
    role: 'Wedding Client',
    text: 'Trevor is a fantastic DJ, I\'ve had the immense pleasure of dancing the night away to Trev\'s fantastic musical stylings and expertise multiple times. After being so impressed on multiple occasions I hired him to DJ my wedding and he made it so much fun for EVERYONE. He knows exactly what songs to play to get people of all ages feeling good and having fun. He\'s one of the best human beings around and will take great care of you, and will definitely have everyone enjoying your event!',
  },
  {
    id: 2,
    name: 'Christine Veltri',
    role: 'Wedding Client',
    text: 'Trevor Keen was a fantastic DJ at our wedding reception in DC! He kept the party going with a great variety of songs for guests of all ages! His enthusiastic energy and sense of humor helped create a fun, lively atmosphere. Trevor was wonderful to work with, he really listened to our requests and helped guide us when we had questions. He was professional and friendly. I highly recommend him for your next event!!!',
  },
  {
    id: 3,
    name: 'Lauren Acre',
    role: 'Wedding Client',
    text: 'Trevor Keen was a fantastic DJ at our wedding reception in DC! He kept the party going with a great variety of songs for guests of all ages! His enthusiastic energy and sense of humor helped create a fun, lively atmosphere. Trevor was wonderful to work with, he really listened to our requests and helped guide us when we had questions. He was professional and friendly. I highly recommend him for your next event!!!',
  },
  {
    id: 4,
    name: 'Tony Meade',
    role: 'Speaker Client',
    text: 'Had the pleasure of attending many weddings in which Trev was the top pick DJ for the occasion. His positive energy and extensive knowledge in music makes the atmosphere pure joy. He built and installed custom speakers for me and they are second to none. The quality craftsmanship and sound blew me away. Recommend him for all DJ, record player repair and custom speaker services!!',
  },
  {
    id: 5,
    name: 'Stephen Fleg | DJ Fleg',
    role: 'Turntable Repair Client',
    text: 'Trev fixed multiple turntables of mine multiple times. He calibrated the pitch faders, cleaned them out and replaced the wiring on my decks. Still working great! Thanks Trev!',
  },
  {
    id: 7,
    name: 'Aaron Siegner | DJ Double A',
    role: 'Turntable Repair Client',
    text: 'Trevor was professional and easy to contact. My decks came back feeling brand new. I\'d definitely hit him up if you need a tune-up!',
  },
  {
    id: 8,
    name: 'Teddy G',
    role: 'Turntable Repair Client',
    text: 'Any turntable issues I\'m sending it to Trev! You\'re my go to guy for all Technics related issues hands down!',
  },
  {
    id: 9,
    name: 'Adian Collazo',
    role: 'Turntable Repair Client',
    text: 'Trev-Ski is clearly the man in the DMV to fix your turntables - ask anyone. He has a great reputation in the DC area and is a quality sound man to boot. I asked him to look at two used Technics turntables almost 10 years ago. I needed them in working order. He repaired them and I have not had a single issue in all these 10 years. Very reliable! He\'ll take care of you.',
  },
  {
    id: 10,
    name: 'Sean Chappel',
    role: 'Turntable Repair Client',
    text: 'Bought Technics from Japan on eBay and both shipped with tonearms that didn\'t properly track. Trevor returned them to me within a week with both tracking beautifully, with both units still going stronger after almost two years of daily DJ useage. He even did a home visit to show me some tricks to keep them working nicely. I have two other units with RCA issues and loose screws that I also intend to have him service. Great service @ unbeatable prices.',
  },
  {
    id: 11,
    name: 'Alex Liedy',
    role: 'Silver Lyan at Riggs Hotel DC',
    text: 'Trevor went above and beyond in putting together a hi-fi system for our bar, and the creativity and professionalism he brought to putting everything together within a budget was second to none.  It was a pleasure working with him the whole way through from concept to installation, and he\'s been super supportive after the fact any time we\'ve had questions about the system',
  },
  {
    id: 12,
    name: 'Paul Vivari',
    role: 'Showtime Lounge DC',
    text: 'Built custom speakers and installed new sound system for my bar in NW DC. Excellent results, amazing sound, and Trevor is very responsive and easy to work with. Would recommend 10/10',
  }
];

const TestimonialSlider = () => {
  const [current, setCurrent] = useState(0);
  const length = testimonials.length;

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(prevCurrent => prevCurrent === length - 1 ? 0 : prevCurrent + 1);
    }, 5000);
    
    return () => clearInterval(interval);
  }, []);

  if (!Array.isArray(testimonials) || testimonials.length <= 0) {
    return null;
  }

  return (
    <SliderContainer>
      <SliderWrapper>
        {testimonials.map((testimonial, index) => (
          <Slide key={testimonial.id} active={index === current}>
            <QuoteIcon>
              <FaQuoteLeft />
            </QuoteIcon>
            <TestimonialText>{testimonial.text}</TestimonialText>
            <TestimonialAuthor>
              <span>{testimonial.name}</span>
              <small>{testimonial.role}</small>
            </TestimonialAuthor>
          </Slide>
        ))}
      </SliderWrapper>
      
      <SliderControls>
        <SliderButton onClick={prevSlide}>
          <FaChevronLeft />
        </SliderButton>
        <SliderDots>
          {testimonials.map((_, index) => (
            <SliderDot 
              key={index} 
              active={index === current}
              onClick={() => setCurrent(index)}
            />
          ))}
        </SliderDots>
        <SliderButton onClick={nextSlide}>
          <FaChevronRight />
        </SliderButton>
      </SliderControls>
    </SliderContainer>
  );
};

const SliderContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 0;
`;

const SliderWrapper = styled.div`
  position: relative;
  min-height: 450px;
  height: auto;
  overflow: hidden;
  
  @media (max-width: 768px) {
    min-height: 550px;
  }
  
  @media (max-width: 576px) {
    min-height: 650px;
  }
`;

const Slide = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  min-height: 100%;
  opacity: ${({ active }) => (active ? 1 : 0)};
  transform: ${({ active }) => (active ? 'translateX(0)' : 'translateX(100%)')};
  transition: all 0.5s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem;
`;

const QuoteIcon = styled.div`
  font-size: 2rem;
  color: var(--color-secondary);
  margin-bottom: 1.5rem;
`;

const TestimonialText = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: var(--color-tertiary);
  margin-bottom: 1.5rem;
  font-style: italic;
`;

const TestimonialAuthor = styled.div`
  display: flex;
  flex-direction: column;
  
  span {
    font-weight: 600;
    color: var(--color-secondary);
    margin-bottom: 0.3rem;
  }
  
  small {
    color: var(--color-tertiary);
    opacity: 0.7;
  }
`;

const SliderControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
`;

const SliderButton = styled.button`
  background: transparent;
  border: none;
  color: var(--color-tertiary);
  font-size: 1.5rem;
  cursor: pointer;
  transition: var(--transition);
  
  &:hover {
    color: var(--color-secondary);
  }
`;

const SliderDots = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 1rem;
`;

const SliderDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ active }) => 
    active ? 'var(--color-secondary)' : 'var(--color-tertiary)'};
  opacity: ${({ active }) => (active ? 1 : 0.3)};
  margin: 0 0.5rem;
  cursor: pointer;
  transition: var(--transition);
  
  &:hover {
    opacity: 0.8;
  }
`;

export default TestimonialSlider; 